module.exports = __webpack_public_path__ + "media/images/dot-icon-b38ec1876f243df8fdd9ec0ab2e5f4c7.svg";